<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgments">
<h1>Acknowledgments</h1>
<p style="text-align: center;">First and foremost, I would like to thank my wife for being my first dedicated beta reader, sounding board, and editor. I could not have written a meaningful and intelligible story without her. I would also like to humbly thank Austin Macauley Publishing for giving me this opportunity.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?54391f03